module.exports = __webpack_public_path__ + "static/media/landing_back.4a36c6c5.png";